
  $(document).ready(function(){
    //hide error alerts

    $(".switch_btn").click(function(){
        $('.error-f_n-cust').hide();
        $('.error-cust').hide();
        $('.errors').hide();
        $('.f_name').removeClass('error_focus');
        $('.l_name').removeClass('error_focus');
        $('.email').removeClass('error_focus');
        $('.password').removeClass('error_focus');
        $('.con_password').removeClass('error_focus');
        $('.fs_pass').removeClass('error_focus');
        $('.rec_pass').removeClass('error_focus');
        $('.l_email').removeClass('error_focus');
    });
    //scroll to top if error
    function errorScroll(){
    $('html, body').animate({
        scrollTop: ($('.error-f_n-cust').offset().top -100)
      }, 1000);
    }

    //Recover Password validation
    //$('.rec_pass_btn').attr('disabled', 'disabled');
    $('form .rec_pass').blur(function () {
    var email = $(this).val();
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
    if (re.test(email)) {
        $('.error-f_n-cust').hide();
        $('.rec_pass_btn').removeAttr('disabled')
        return true;
      } else {
        $('.error-f_n-cust').show();
        $('.error-f_n-cust').html('Please enter valid Email Id!');
        $('.rec_pass').addClass('error_focus');
    $('.rec_pass_btn').attr('disabled', 'disabled');
        return false;
      }
    });

     $(".rec_pass_btn").click(function(){
    var rec_pass = $('.rec_pass').val();

       if(rec_pass == 0){
        var userinput = rec_pass;
        var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
          if(!pattern.test(userinput))
          {
            $('.error-f_n-cust').show();
            $('.rec_pass').addClass('error_focus');
            $('.error-f_n-cust').html('Please enter a valid Email Id!');
            return false;
          }
        }
      });

    //Login form validation
    //$('.login_id').attr('disabled', 'disabled');
    $('form .l_email').blur(function () {
    var email = $(this).val();
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
    if (re.test(email)) {
        $('.error-f_n-cust').hide();
        $('.login_id').removeAttr('disabled')
        return true;
      } else {
        $('.error-f_n-cust').show();
        $('.error-f_n-cust').html('Please enter valid Email Id!');
        $('.l_email').addClass('error_focus');
    $('.login_id').attr('disabled', 'disabled');
        return false;
      }
    });

    $('form .l_pass').blur(function () {$('.l_pass').removeClass('error_focus'); $('.error-f_n-cust').hide(); });

     $(".login_id").click(function(){
    var l_email = $('.l_email').val();
      var l_pass = $('.l_pass').val();

       if(l_email == 0){
        var userinput = l_email;
        var pattern = /^\b[A-Z0-9._%-]+@[A-Z0-9.-]+\.[A-Z]{2,4}\b$/i
          if(!pattern.test(userinput))
          {
            $('.error-f_n-cust').show();
            $('.error-f_n-cust').html('Please enter a valid Email Id!');
          $('.l_email').addClass('error_focus');
            return false;
          }
        }else if(l_pass == 0){
            $('.error-f_n-cust').show();
            $('.error-f_n-cust').html('Please fill the Password field!');
          $('.l_pass').addClass('error_focus');
            return false;
          }
      });


    $('form .r_email').blur(function () {
    var email = $(this).val();
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/igm;
    if (re.test(email)) {
        $('.error-f_n-cust').hide();
        $('.r_login').removeAttr('disabled')
        return true;
      } else {
        $('.error-f_n-cust').show();
        $('.error-f_n-cust').html('Please enter valid Email Id!');
        $('.r_email').addClass('error_focus');
    $('.r_login').attr('disabled', 'disabled');
        return false;
      }
    });

    $(".r_login").click(function(){
    var r_email = $('.r_email').val();

       if(r_email == 0){
            $('.error-f_n-cust').show();
            $('.error-f_n-cust').html('Please enter a valid Email Id!');
          $('.r_email').addClass('error_focus');
            return false;
       }
      });



    //registration form validation
    var f_name = $('.f_name').val();
    var l_name = $('.l_name').val();
    var email = $('.email').val();
    var password = $('.fs_pass').val();
    var con_password = $('.con_password').val();


    $('form .f_name').blur(function () {$('.f_name').removeClass('error_focus'); $('.error-f_n-cust').hide(); });
    $('form .l_name').blur(function () {$('.l_name').removeClass('error_focus'); $('.error-f_n-cust').hide(); });
    $('form .fs_pass').blur(function () {$('.fs_pass').removeClass('error_focus'); $('.error-f_n-cust').hide(); });
    $('form .con_password').blur(function () {$('.con_password').removeClass('error_focus'); $('.error-f_n-cust').hide(); });


     $(".button_id").click(function(){
      var f_name = $('.f_name').val();
      var l_name = $('.l_name').val();
      var email = $('.email').val();
      var password = $('.fs_pass').val();
      var con_password = $('.con_password').val();

      if((f_name == 0) && (l_name == 0) && (email == 0) &&  (password == 0) && (con_password == 0)){
      $('.error-f_n-cust').show();
      $('.error-f_n-cust').html('All fields are Mandatory, Kindly fill all fields!');
        $('.f_name').addClass('error_focus');
        $('.l_name').addClass('error_focus');
        $('.email').addClass('error_focus');
        $('.fs_pass').addClass('error_focus');
        $('.con_password').addClass('error_focus');
        errorScroll()
        return false;
      }
       else if(f_name == 0){
        $('.error-f_n-cust').show();
        $('.error-cust').hide();
        $('.error-f_n-cust').html('Please fill the First Name field!');
        $('.f_name').addClass('error_focus');
        $('.l_name').removeClass('error_focus');
        $('.email').removeClass('error_focus');
        $('.fs_pass').removeClass('error_focus');
        $('.con_password').removeClass('error_focus');
        errorScroll()
        return false;
      }else if(l_name == 0){
        $('.error-f_n-cust').show();
        $('.error-cust').hide();
        $('.error-f_n-cust').html('Please fill the Last Name field!');
        $('.f_name').removeClass('error_focus');
        $('.l_name').addClass('error_focus');
        $('.email').removeClass('error_focus');
        $('.fs_pass').removeClass('error_focus');
        $('.con_password').removeClass('error_focus');
        errorScroll()
        return false;
      }else if(email == 0){
        $('.error-f_n-cust').show();
        $('.error-cust').hide();
        $('.error-f_n-cust').html('Please fill the Email field!');
        $('.f_name').removeClass('error_focus');
        $('.l_name').removeClass('error_focus');
        $('.email').addClass('error_focus');
        $('.fs_pass').removeClass('error_focus');
        $('.con_password').removeClass('error_focus');
         errorScroll()
        return false;
      }else if(password == 0){
        $('.error-f_n-cust').show();
        $('.error-cust').hide();
        $('.error-f_n-cust').html('Please fill the Password field!');
        $('.f_name').removeClass('error_focus');
        $('.l_name').removeClass('error_focus');
        $('.email').removeClass('error_focus');
        $('.fs_pass').addClass('error_focus');
        $('.con_password').removeClass('error_focus');
        errorScroll()
        return false;
      }else if(con_password == 0){
        $('.error-f_n-cust').show();
        $('.error-cust').hide();
        $('.error-f_n-cust').html('Please fill the Confirm Password field!');
        $('.f_name').removeClass('error_focus');
        $('.l_name').removeClass('error_focus');
        $('.email').removeClass('error_focus');
        $('.fs_pass').removeClass('error_focus');
        $('.con_password').addClass('error_focus');
        errorScroll()
        return false;
      }else{
      if(password.length > 6){
            re = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,}$/;

            if(!re.test(password)) {
              $('.error-f_n-cust').hide();
              $('.error-cust').show();
              $('.error-cust').html("Password must contain between Special Character(#?!@$%^&*-), (a-z), (A-Z), (0-9)!");
              $('.f_name').removeClass('error_focus');
              $('.l_name').removeClass('error_focus');
              $('.email').removeClass('error_focus');
              $('.fs_pass').addClass('error_focus');
              $('.con_password').addClass('error_focus');
              return false;
            }
            else if(password == con_password){
              $('.error-f_n-cust').hide();
              return true;
            }else{
              $('.error-f_n-cust').hide();
              $('.error-cust').show();
              $('.error-cust').html("Password doesn't match, Please Check!");
              $('.f_name').removeClass('error_focus');
              $('.l_name').removeClass('error_focus');
              $('.email').removeClass('error_focus');
              $('.fs_pass').addClass('error_focus');
              $('.con_password').addClass('error_focus');
              return false;
            }
        }else{
        $('.error-f_n-cust').hide();
        $('.error-cust').show();
        $('.error-cust').html("Password must be more than 6 characters and must contain at least One Special Character(#?!@$%^&*-), (a-z), (A-Z), (0-9)!");
        $('.f_name').removeClass('error_focus');
        $('.l_name').removeClass('error_focus');
        $('.email').removeClass('error_focus');
        $('.fs_pass').addClass('error_focus');
        $('.con_password').removeClass('error_focus');
          return false;
        }
      }
    });
   });
